import {render, cookieExistiert} from "../../assets/js/utils.js";

class ReihenSliderBootstrap extends HTMLElement {
  constructor() {
    super();
    this.initListener();
  }

  disconnectedCallback() {
    this.disconnect();
  }

  get uri() {
    return this.dataset["uri"];
  }

  initListener() {
    this.observer = this.initObserver();
    this.addAnchorScrollListener();
  }

  disconnect() {
    this.observer.disconnect();
  }

  destroy() {
    this.remove();
  }

  addAnchorScrollListener() {
    document.addEventListener("sbe.anchorScroll.start", () => {
      this.disconnect();
    }, { once: true });
    document.addEventListener("sbe.anchorScroll.finish", () => {
      this.initListener();
    }, { once: true });
  }

  initObserver() {
    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        this.observeReihenSlider(entry);
      }
    });
    observer.observe(this);
    return observer;
  }

  observeReihenSlider(entry) {
    if (entry.isIntersecting) {
      this.initializeReihenSlider();
    }
  }

  async initializeReihenSlider() {
    try {
      const response = await fetch(this.uri);
      const html = await response.text();
      render(this, html, true);
    } catch (error) {
      this.destroy();
    } finally {
      this.disconnect();
    }
  }
}

if (!customElements.get("reihen-slider-bootstrap")) {
  customElements.define("reihen-slider-bootstrap", ReihenSliderBootstrap);
}
